/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Button, Box, Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Services';
import Chip from '@material-ui/core/Chip';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles'

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function MarketListing() {
    const screenCode = 'MARKET';
    let encrypted = "";
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        groupID: "0",
    });
    const [groupList, setGroupList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false
    });
    const GroupSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
        },
        validationSchema: GroupSearchSchema,
        onSubmit: (values) => {
            trackPromise(GetMarketsByGroupID(values.groupID));
            sessionStorage.setItem("marketScreanData", JSON.stringify(values.groupID));
            sessionStorage.setItem("marketScreanPage", JSON.stringify(page));
        },
    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        const marketScreanData = JSON.parse(sessionStorage.getItem('marketScreanData'));
        const marketScreanPage = JSON.parse(sessionStorage.getItem('marketScreanPage'));
        getPermissions(marketScreanData, marketScreanPage);
    }, []);

    useEffect(() => {
        GetAllGroups();
    }, []);

    useEffect(() => {
        setTableData([])
    }, [formik.values.groupID]);

    async function getPermissions(marketScreanData, marketScreanPage) {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'MARKET');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });

        const isInitialLoading = marketScreanData === null

        if (isInitialLoading) {
            setValues({
                ...values,
                groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            });
        }else{
            setValues({
                ...values,
                groupID: marketScreanData,
            });

            GetMarketsByGroupID(marketScreanData);
            if (marketScreanPage !== null) {
                setPage(marketScreanPage);
            }
        }
    }

    async function GetAllGroups() {
        var resNew = await services.GetAllGroupsForMarketScreen();
        if (resNew != null) {
            setGroupList(resNew);
        }
    }

    async function GetMarketsByGroupID(groupID) {
        var res = await services.GetMarketsByGroupIDForMarketScreen(groupID);
        if (res != null) {
            setTableData(res);
        }
        setPage(0);
    }

    async function handleClick(datas) {
        encrypted = await AESEncryptionParam(datas.toString());
        navigate('/dashboard/viewMarket/AddEdit/' + encrypted)
    }

    async function clearAll() {
        setPage(0);
        setTableData([]);
        sessionStorage.removeItem("marketScreanData");
        sessionStorage.removeItem("marketScreanPage");
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Market |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/viewMarket/AddEdit/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="Market"
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Stack width={450}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Group *"
                                            value={formik.values.groupID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('groupID')}
                                            error={Boolean(touched.groupID && errors.groupID)}
                                            helperText={touched.groupID && errors.groupID}
                                            InputProps={{
                                                readOnly: !permissionList.isGroupFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}>Select Group</MenuItem>
                                            {groupList.map((option) => (
                                                <MenuItem key={option.groupID} value={option.groupID}>
                                                    {option.groupName}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Stack>
                                    <Grid item md={8} xs={12}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                color='error'
                                                variant="outlined"
                                                onClick={() => clearAll()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Stack>
                                    </Grid>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {tableData.length == 0 ?
                        <SearchNotFound searchQuery="Markets" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                <TableContainer component={Paper} >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left">Market Code</TableCell>
                                                <TableCell align="left">Market Name</TableCell>
                                                <TableCell align="left">Market Description</TableCell>
                                                <TableCell align="left">Status</TableCell>
                                                <TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : tableData
                                            ).map((row) => (
                                                <TableRow key={row.marketID}>
                                                    <TableCell align="left" component="th" scope="row">
                                                        {row.marketCode}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.marketName}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.marketDescription == null || row.marketDescription == "" ? '-' : row.marketDescription}
                                                    </TableCell>
                                                    <TableCell align="left">{row.isActive ? <Chip size="small" label="Active" style={{ color: 'green' }} /> : <Chip size="small" label="Inactive" style={{ color: 'red' }} />}</TableCell>
                                                    <TableCell align="center">{<IconButton aria-label="delete" onClick={() => handleClick(row.marketID)}  >
                                                        <EditIcon />
                                                    </IconButton>}</TableCell>
                                                </TableRow>
                                            ))}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={6} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                    colSpan={6}
                                                    count={tableData.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            'aria-label': 'rows per page',
                                                        },
                                                        native: true,
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Stack>
                    }
                </Container>
            </Page>
        </>
    );
}